<template>
    <div class="float-left mr-1">
        <b-button variant="primary" @click="abrirModal()">
            <span> <i class="fa fa-plus mr-2"></i> Inserir Anexo </span>
        </b-button>
        <b-modal
            id="modalInserirDocumento"
            size="lg"
            v-model="mostrarModal"
            no-close-on-backdrop
        >
            <div slot="modal-title">
                Anexo do Processo {{ processoAta.nuProcesso }} -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Descrição do Arquivo</label>
                        <b-form-textarea
                            :rows="4"
                            v-model="anexoDto.vcDescricaoAnexo"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A descrição do documento é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Arquivo</label>
                        <b-form-file
                            v-model="anexoDto.arquivo"
                            :state="Boolean(anexoDto.arquivo)"
                            placeholder="Selecione o arquivo..."
                            ref="arquivoInput"
                        ></b-form-file>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button variant="primary" class="ml-1" @click.stop="salvar()"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import AtaDirexServicos from '../AtaDirexServicos'

export default {
    props: {
        processoAta: {
            type: Object,
            default: () => ({})
        },
        desativarBotao: Boolean
    },

    data() {
        return {
            mostrarModal: false,
            operacao: 'NOVO',
            erros: [],

            anexoDto: {
                idAnexo: 0,
                idContrato: null,
                idProcessoAta: 0,
                vcDescricaoAnexo: '',
                vcNomeArquivo: '',
                nuSituacaoAnexo: 1,
                arquivo: null
            }
        }
    },

    methods: {
        abrirModal() {
            this.anexoDto.vcDescricaoAnexo = ''
            this.anexoDto.vcNomeArquivo = ''

            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar() {
            this.anexoDto.idProcessoAta = this.processoAta.idProcessoAta
            this.anexoDto.vcNomeArquivo = this.anexoDto.arquivo.name
            this.$store.dispatch('addRequest')
            AtaDirexServicos.inserirAnexo(this.anexoDto).then((response) => {
                if (response) {
                    if (response.success) {
                        this.acoes = response.data
                        this.$emit('ListarAnexos')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })

            this.fecharModal()
        }
    }
}
</script>
